export default [
  {
    path: '/promo-codes',
    name: 'promo-codes',
    component: () => import('@/views/marketing/promo-codes/pages/PromoCodesList.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'promo-codes',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Promo Codes',
    },
  },
  {
    path: '/promo-codes/new',
    name: 'promo-codes-new',
    component: () => import('@/views/marketing/promo-codes/pages/AddPromoCode.vue'),
    meta: {
      resource: 'promo-codes',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Promo Code',
      breadcrumb: [
        {
          text: 'Promo Codes',
          to: '/promo-codes',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/promo-codes/edit/:id',
    name: 'edit-promo-codes',
    component: () => import('@/views/marketing/promo-codes/pages/EditPromoCode.vue'),
    meta: {
      resource: 'promo-codes',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Promo Code',
      breadcrumb: [
        {
          text: 'Promo Codes',
          to: '/promo-codes',
        },
      ],
    },
    allowedCountries: ['LY'],
  },
]
